import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Button, Divider, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import { useCommonStyles } from '../../../utils';
import CommonAutoComplete from '../../Common/CommonAutoComplete';
import { getVendors } from '../../../Redux/Actions/Vendor';
import ErrorHandler from '../../../lib/errorHandler';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CommonTextField from '../../Common/CommonTextField';
import CommonDatePicker from '../../Common/CommonDatePicker';
import { InventoryTypeInum } from '../../../lib/enum';
import { getInventoryFields } from '../../../Redux/Actions/Inventory';
import LotNumberTable from './LotNumberTable';
import { addLotNumber, getAllPOList, getPOItem, getPoNumbersByVendor } from '../../../Redux/Actions/PurchaseEntry';
import ErrorMessage from '../../Common/ErrorMessage';
import StyledTableRow from '../../Common/StyledTableRow';
import StyledTableCell from '../../Common/StyledTableCell';
import NoDataFound from '../../Common/NoDataFound';
import IconBackground from '../../Common/IconBackground';
import { isCompleteDate } from '../../../lib/standardDateFormat';

const AddUpdateLotNumber = ({ activeTab, setIsEditMode, isEditMode, uniqueReelId, setUniqueReelId, setIsOpenAddUpdateLotNumber, setData, data, _getLotNumber, setSelectedYear, selectedYear, yearOptions, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [vendorPage, setVendorPage] = useState(1);
    const [vendorTotalCount, setVendorTotalCount] = useState();
    const [vendorList, setVendorList] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);
    const [searchVendor, setSearchVendor] = useState();

    const [poNumberPage, setPoNumberPage] = useState(1);
    const [poNumberTotalCount, setPoNumberTotalCount] = useState();
    const [poNumberList, setPoNumberList] = useState([]);
    const [poNumberOptions, setPoNumberOptions] = useState([]);
    const [searchPoNumber, setSearchPoNumber] = useState();

    const [sizePage, setSizePage] = useState(1);
    const [sizeTotalCount, setSizeTotalCount] = useState();
    const [sizeList, setSizeList] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [searchSize, setSearchSize] = useState();

    const [purcheseEnteryData, setPurcheseEnteryData] = useState([]);
    const [tabelItemData, setTabelItemData] = useState([]);


    const [errors, setErrors] = useState({})
    // ============== Handler ==============
    const handleChange = (name, value) => {
        if (name == "vendor") {
            setData({ ...data, [name]: value, poNumber: "" })
            setPoNumberList([])
        } else if (name === "totalWeight") {
            const weight = parseFloat((value / data?.reelNumber).toFixed(3));
            setData({ ...data, [name]: value, weight });
        } else if (name === "reelNumber") {
            const weight = parseFloat((data?.totalWeight / value).toFixed(3));
            setData({ ...data, [name]: value, weight });
        }
        else {
            setData({ ...data, [name]: value })
        }
    }

    const handleDeleteRow = (row) => {
        const updatedData = tabelItemData?.filter((ele) => ele?.itemName !== row?.itemName)
        setTabelItemData(updatedData);

    }
    const addTableItem = () => {
        if (data?.selectedItem) {
            const newItem = {
                "itemName": data?.selectedItem?.itemName,
                "GSMMIC": data?.selectedItem?.GSMMIC,
                "quantity": "",
                "weight": "",
                "noOfReels": ""
            }
            const isItemExists = tabelItemData?.some(order => order.itemName === newItem.itemName);
            if (isItemExists) {
                setSnackBar("error", "Item already exists.");
            } else {
                setTabelItemData(prevData => [...prevData, newItem]);
                setData({ ...data, selectedItem: "" })
            }
        } else {
            setSnackBar("error", "Please select an item.");
        }
    };

    const handleChangeForItems = (row, value, name) => {
        const updatedItems = tabelItemData?.map((ele) => {
            if (ele?.itemName === row?.itemName) {
                return {
                    ...ele,
                    [name]: value,
                };
            } else {
                return { ...ele };
            }
        });
        if (name == "noOfReels") {
            setData({ ...data, reelNumber: updatedItems?.reduce((sum, item) => sum + +item?.noOfReels, 0) })
        }
        if (name == "quantity") {
            setData({ ...data, totalWeight: updatedItems?.reduce((sum, item) => sum + +item?.quantity, 0) })
        }
        setTabelItemData(updatedItems);
    };
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdateLotNumber(false); setData({}); setUniqueReelId(""); setIsEditMode(false); _getLotNumber(); setSearchValue('') }}>
            Purchase Entry
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`${isEditMode ? "Edit" : "Create New"} Lot Number`}
        </Typography>,
    ];

    // ============= validation ============= 

    const validstep = () => {
        let errors = {};
        let formIsValid = true;

        if (!data?.vendor?.name) {
            formIsValid = false;
            errors.vendor = "Please select vendor."
        }
        if (!data?.poNumber?.poNumber) {
            formIsValid = false;
            errors.poNumber = "Please select po number."
        }
        if (!data?.lotNumber) {
            formIsValid = false;
            errors.lotNumber = "Please enter lot number."
        }
        // if (!data?.companyName) {
        //     formIsValid = false;
        //     errors.companyName = "Please enter company name."
        // }
        if (!data?.invoiceNumber) {
            formIsValid = false;
            errors.invoiceNumber = "Please enter invoice number."
        }
        if (!data?.invoiceDate) {
            formIsValid = false;
            errors.invoiceDate = "Please select invoice date."
        }
        if (data?.invoiceDate) {
            if (!isCompleteDate(data?.invoiceDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid invoice date")
            }
        }
        if (!data?.receiveDate) {
            formIsValid = false;
            errors.receiveDate = "Please select receive date."
        }
        if (data?.receiveDate) {
            if (!isCompleteDate(data?.receiveDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid receive date")
            }
        }
        if (!data?.totalWeight) {
            formIsValid = false;
            errors.totalWeight = "Please enter total weight."
        }
        if (activeTab?.value !== 3) {
            if (!data?.type) {
                formIsValid = false;
                errors.type = "Please enter type."
            }
        }
        // if (!data?.gsm) {
        //     formIsValid = false;
        //     errors.gsm = `Please enter ${data?.poNumber?.category == 1 ? "GSM / MIC" : data?.poNumber?.category == 2 ? "GSM / MIC" : data?.poNumber?.category == 3 ? "Chemical Code" : data?.poNumber?.category == 4 ? "Pantone number" : "GSM / MIC"}.`
        // }
        if (!data?.reelNumber) {
            formIsValid = false;
            errors.reelNumber = "Please enter reel number."
        }
        // if (!data?.size?.size) {
        //     formIsValid = false;
        //     errors.size = "Please select size."
        // }
        // if (!data?.weight) {
        //     formIsValid = false;
        //     errors.weight = "Please enter weight."
        // }
        if (tabelItemData?.length == 0) {
            formIsValid = false;
            setSnackBar("error", "Please Seleact At Least One Item")
        } else {
            if (!tabelItemData?.every((ele) => ele?.quantity)) {
                formIsValid = false;
                setSnackBar("error", "Please enter a valid quantity and number of reels for each item")
            }
        }
        setErrors(errors)
        return formIsValid
    }

    // ============== Get Vendor API ==============
    const _getVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : vendorPage,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        { (vendorList?.length !== vendorTotalCount) && setVendorPage(vendorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText ? searchText : "");
            setVendorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setVendorList([...vendorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        setVendorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText);
            setVendorList(response?.payload?.data?.response);
        }
    };

    // ============== Get PO Number API ==============
    const _getPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "vendorName": data?.vendor?.name,
            "limit": 10,
            "page": p ? p : poNumberPage,
            "search": searchText ? searchText : "",
            category: activeTab?.value
        };
        response = await dispatch(getPoNumbersByVendor(body));
        { (poNumberList?.length !== poNumberTotalCount) && setPoNumberPage(poNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText ? searchText : "");
            setPoNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setPoNumberList([...poNumberList, ...response?.payload?.data?.response]);
                } else {
                    setPoNumberList([])
                }
            }
        }
    };

    const handleChangeInputForPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "vendorName": data?.vendor?.name,
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getPoNumbersByVendor(body));
        setPoNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText);
            setPoNumberList(response?.payload?.data?.response);
        }
    };
    // ============== Get Size API ==============
    const _getSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p ? p : sizePage
        };
        response = await dispatch(getInventoryFields(body));
        { (sizeList?.length !== sizeTotalCount) && setSizePage(sizePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText ? searchText : "");
            setSizeTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setSizeList([...sizeList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p
        };
        response = await dispatch(getInventoryFields(body));
        setSizePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText);
            setSizeList(response?.payload?.data?.response);
        }
    };



    // ============= add Inventory Field API =============
    const _addUpdateLotNumber = async () => {
        if (validstep()) {
            setFullPageLoader(true);
            let response;

            const finalTableData = tabelItemData?.map((ele) => {
                return {
                    "itemName": ele?.itemName,
                    "GSMMIC": ele?.GSMMIC,
                    "weight": (ele?.quantity || 0) / (ele?.noOfReels || 0) || 0,
                    "noOfReels": +ele?.noOfReels

                }
            })
            let body = {
                "year": selectedYear?.id,
                "vendorName": data?.vendor?.name,
                "poNumber": data?.poNumber?.poNumber,
                "category": data?.poNumber?.category,
                "lotNumber": data?.lotNumber,
                "companyName": data?.companyName,
                "invoiceNumber": data?.invoiceNumber,
                "invoiceDate": data.invoiceDate ? dayjs(data.invoiceDate).format("YYYY-MM-DD") : null,
                "receiveDate": data.receiveDate ? dayjs(data.receiveDate).format("YYYY-MM-DD") : null,
                "totalWeight": data?.totalWeight,
                "type": data?.type,
                "externalItemNo": data?.externalItemNumber,
                // "GSMMIC": data?.gsm,
                "reelNumber": String(data?.reelNumber),
                "size": data?.size?.size,
                "sizeUnit": data?.size?.sizeUnit,
                // "weight": data?.weight,
                "items": finalTableData
            }
            response = await dispatch(addLotNumber(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setData({})
                    setUniqueReelId(response?.payload?.data?.response?.uniqueId)
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };

    const _getPEItemByLotNumber = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            "poNumber": data?.poNumber?.poNumber,
            "category": data?.poNumber?.category,
        }
        response = await dispatch(getPOItem(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setPurcheseEnteryData(response?.payload?.data?.response?.Items)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ====================== Use Effects ======================
    useEffect(() => {
        if (!uniqueReelId) {
            _getVendor();
            _getSize();
        }
    }, [uniqueReelId]);

    useEffect(() => {
        if (data?.poNumber?.poNumber && data?.poNumber?.category) {
            _getPEItemByLotNumber();
        }
    }, [data?.poNumber])

    useEffect(() => {
        if (data?.vendor) {
            _getPoNumber(1);
        }
    }, [data?.vendor]);

    useEffect(() => {
        setVendorOptions(vendorList?.map((e) => e));
    }, [vendorList]);

    useEffect(() => {
        setPoNumberOptions(poNumberList?.map((e) => e));
    }, [poNumberList]);

    useEffect(() => {
        setSizeOptions(sizeList?.map((e) => e));
    }, [sizeList]);

    return (
        uniqueReelId ?
            <LotNumberTable _getLotNumber={_getLotNumber} isEditMode={isEditMode} setIsEditMode={setIsEditMode} uniqueReelId={uniqueReelId} setUniqueReelId={setUniqueReelId} setIsOpenAddUpdateLotNumber={setIsOpenAddUpdateLotNumber} />
            :
            <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
                <Grid item xs={12}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`${isEditMode ? "Edit" : "Create New"} Lot Number`}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px" }}>
                        <Box padding={"25px"}>
                            <Grid container spacing={2} >
                                <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> Create New Lot No.</Typography>
                                    <CommonAutoComplete
                                        clearIcon={false}
                                        width={"100px"}
                                        options={yearOptions || []}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={selectedYear || null}
                                        onChange={(e, newValue) => setSelectedYear(newValue)}
                                        optionsMargin={1}
                                        sx={{
                                            padding: "2px", "& .MuiOutlinedInput-root": {
                                                paddingRight: "2px !important"
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonAutoComplete
                                        valid
                                        label="Vendor"
                                        placeholder="Select Vendor"
                                        options={vendorOptions || []}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={data?.vendor || null}
                                        onChange={(e, newValue) => handleChange("vendor", newValue)}
                                        loadData={(vendorOptions?.length !== vendorTotalCount) ? _getVendor : undefined}
                                        handleSearch={(e) => handleChangeInputForVendor(1, e?.target?.value)}
                                        searchValue={searchVendor}
                                    />
                                    <ErrorMessage text={!data?.vendor?.name ? errors.vendor : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonAutoComplete
                                        valid
                                        label="PO Number"
                                        placeholder="Select PO Number"
                                        options={poNumberOptions || []}
                                        getOptionLabel={(option) => option?.poNumber || ""}
                                        value={data?.poNumber || null}
                                        onChange={(e, newValue) => handleChange("poNumber", newValue)}
                                        loadData={(poNumberOptions?.length !== poNumberTotalCount) ? _getPoNumber : undefined}
                                        handleSearch={(e) => handleChangeInputForPoNumber(1, e?.target?.value)}
                                        searchValue={searchPoNumber}
                                    />
                                    <ErrorMessage text={!data?.poNumber?.poNumber ? errors.poNumber : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        valid
                                        type="text"
                                        label="Lot Number"
                                        name="lotNumber"
                                        value={data.lotNumber}
                                        placeholder="Enter The Lot Number"
                                        onChange={(e) => handleChange("lotNumber", e.target.value)}
                                    />
                                    <ErrorMessage text={!data?.lotNumber ? errors.lotNumber : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        // valid
                                        type="text"
                                        label="Company Name"
                                        name="companyName"
                                        value={data.companyName}
                                        placeholder="Enter The Company Name"
                                        onChange={(e) => handleChange("companyName", e.target.value)}
                                    />
                                    {/* <ErrorMessage text={!data?.companyName ? errors.companyName : ""} /> */}
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        valid
                                        type="text"
                                        label="Invoice Number"
                                        name="invoiceNumber"
                                        value={data.invoiceNumber}
                                        placeholder="Enter The Invoice Number"
                                        onChange={(e) => handleChange("invoiceNumber", e.target.value)}
                                    />
                                    <ErrorMessage text={!data?.invoiceNumber ? errors.invoiceNumber : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonDatePicker
                                        valid
                                        label="Invoice Date"
                                        onChange={(value) => handleChange("invoiceDate", value)}
                                        value={data?.invoiceDate || null}
                                        name="invoiceDate"
                                    />
                                    <ErrorMessage text={!data?.invoiceDate ? errors.invoiceDate : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonDatePicker
                                        valid
                                        label="Receive Date "
                                        onChange={(value) => handleChange("receiveDate", value)}
                                        value={data?.receiveDate || null}
                                        name="receiveDate"
                                    />
                                    <ErrorMessage text={!data?.receiveDate ? errors.receiveDate : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        valid
                                        type="number"
                                        label="Total Weight"
                                        disabled
                                        name="totalWeight"
                                        value={data.totalWeight}
                                        placeholder="Enter The Total Weight"
                                        onChange={(e) => {
                                            if (+e?.target?.value >= 0) {
                                                handleChange("totalWeight", e.target.value)
                                            } else {
                                                return;
                                            }
                                        }}
                                    />
                                    <ErrorMessage text={!data?.totalWeight ? errors.totalWeight : ""} />
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider />
                        <Grid container spacing={2} padding={"25px"}>
                            {activeTab?.value !== 3 &&
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        valid
                                        type="text"
                                        label="Type"
                                        name="type"
                                        value={data.type}
                                        placeholder="Enter The Type"
                                        onChange={(e) => handleChange("type", e.target.value)}
                                    />
                                    <ErrorMessage text={(activeTab?.value !== 3 && !data?.type) ? errors.type : ""} />
                                </Grid>
                            }
                            {activeTab?.value !== 3 &&
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonTextField
                                        type="number"
                                        label="External Item No."
                                        name="externalItemNumber"
                                        value={data.externalItemNumber}
                                        placeholder="Enter The External Item No."
                                        onChange={(e) => {
                                            if (+e?.target?.value >= 0) {
                                                handleChange("externalItemNumber", e.target.value)
                                            } else {
                                                return;
                                            }
                                        }}
                                    />
                                </Grid>
                            }
                            {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                                <CommonTextField
                                    valid
                                    type={(data?.poNumber?.category == 3 || data?.poNumber?.category == 4) ? "text" : "number"}
                                    label={data?.poNumber?.category == 1 ? "GSM / MIC" : data?.poNumber?.category == 2 ? "GSM / MIC" : data?.poNumber?.category == 3 ? "Chemical Code" : data?.poNumber?.category == 4 ? "Ink Code" : "GSM / MIC"}
                                    name="gsm"
                                    value={data?.gsm}
                                    placeholder={`Enter The ${data?.poNumber?.category == 1 ? "GSM / MIC" : data?.poNumber?.category == 2 ? "GSM / MIC" : data?.poNumber?.category == 3 ? "Chemical Code" : data?.poNumber?.category == 4 ? "Ink Code" : "GSM / MIC"}`}
                                    onChange={(data?.poNumber?.category == 3 || data?.poNumber?.category == 4) ? (e) => handleChange("gsm", e.target.value) : (e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChange("gsm", e.target.value)
                                        } else {
                                            return;
                                        }
                                    }}
                                />
                                <ErrorMessage text={!data?.gsm ? errors.gsm : ""} />
                            </Grid> */}
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <CommonTextField
                                    valid
                                    type="number"
                                    label={activeTab?.value == 3 ? "Total NOS" : "Total Reels"}
                                    name="reelNumber"
                                    disabled
                                    value={data.reelNumber}
                                    placeholder={activeTab?.value == 3 ? "Enter The NOS Number" : "Enter The Reel Number"}
                                    onChange={(e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChange("reelNumber", e.target.value)
                                        } else {
                                            return;
                                        }
                                    }}
                                />
                                <ErrorMessage text={!data?.reelNumber ? errors.reelNumber : ""} />
                            </Grid>
                            {/* {(data?.poNumber?.category == 1 || data?.poNumber?.category == 2 || data?.poNumber?.category == 5) &&
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <CommonAutoComplete
                                        label="Size"
                                        placeholder="Select Size"
                                        options={sizeOptions || []}
                                        getOptionLabel={(option) => `${option?.size} (${option?.sizeUnit})` || ""}
                                        value={data?.size || null}
                                        onChange={(e, newValue) => handleChange("size", newValue)}
                                        loadData={(sizeOptions?.length !== sizeTotalCount) ? _getSize : undefined}
                                        handleSearch={(e) => handleChangeInputForSize(1, e?.target?.value)}
                                        searchValue={searchSize}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <CommonTextField
                                    type="number"
                                    label="Weight"
                                    valid
                                    disabled
                                    name="weight"
                                    value={data?.weight}
                                    placeholder="Enter The Weight"
                                    onChange={(e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChange("weight", e.target.value)
                                        } else {
                                            return;
                                        }
                                    }}
                                />
                                <ErrorMessage text={!data?.weight ? errors.weight : ""} />
                            </Grid> */}
                            <Grid item sm={7} md={8} lg={9} >
                                <CommonAutoComplete
                                    valid
                                    label="Select Items"
                                    placeholder="Select Item"
                                    options={purcheseEnteryData || []}
                                    getOptionLabel={(option) => option?.itemName || ""}
                                    value={data?.selectedItem || null}
                                    onChange={(e, newValue) => handleChange("selectedItem", newValue)}
                                />
                            </Grid>
                            <Grid item sm={5} md={4} lg={3} alignSelf={"end"} >
                                <Button variant='outlined' onClick={() => addTableItem()} sx={{ borderRadius: "10px", backgroundColor: "#FFF", padding: "7px 1rem", "&:hover": { backgroundColor: "#FFF" }, }} startIcon={<AddCircleIcon />}>Add items</Button>
                            </Grid>
                            <Grid item xs={12} width={"100px"}>
                                <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <StyledTableRow isBordered isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                    <StyledTableCell>{"Item(s)"}</StyledTableCell>
                                                    <StyledTableCell>{"Total Quantity"}</StyledTableCell>

                                                    <StyledTableCell>{activeTab?.value == 3 ? "Number Of Units" : "Number Of Reels"}</StyledTableCell>
                                                    <StyledTableCell>{activeTab?.value == 3 ? "Weight Per Units" : "Weight Per Reels"}</StyledTableCell>
                                                    <StyledTableCell>{"Delete"}</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody isBordered>
                                                {tabelItemData?.length > 0 ?
                                                    <>
                                                        {tabelItemData?.map((row, index) => (
                                                            <React.Fragment key={index}>
                                                                <StyledTableRow isBordered>
                                                                    <StyledTableCell isBordered>
                                                                        <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "300px" }}>
                                                                            {row?.itemName}
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered align='center'>
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="quantity"
                                                                            value={row?.quantity}
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            onChange={(e) => {
                                                                                if (+e?.target?.value >= 0) {
                                                                                    handleChangeForItems(row, e.target.value, "quantity")
                                                                                } else {
                                                                                    return;
                                                                                }
                                                                            }}
                                                                        />
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered align='center'>
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="noOfReels"
                                                                            value={row?.noOfReels}
                                                                            placeholder="Ex. 10"
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                            onChange={(e) => {
                                                                                if (+e?.target?.value >= 0) {
                                                                                    handleChangeForItems(row, e.target.value, "noOfReels")
                                                                                } else {
                                                                                    return;
                                                                                }
                                                                            }}
                                                                        />
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered >
                                                                        <CommonTextField
                                                                            width={"80px"}
                                                                            type="number"
                                                                            name="weight"
                                                                            value={(row?.quantity || 0) / (row?.noOfReels || 0) || 0}
                                                                            placeholder="Ex. 10"
                                                                            disabled
                                                                            sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        />
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered align='center' >
                                                                        <IconBackground icon={"delete"}
                                                                            onClick={(e) => handleDeleteRow(row)} />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            </React.Fragment>
                                                        ))}
                                                    </>
                                                    :
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={12}>
                                                            <NoDataFound />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Grid>
                            <Grid item xs={12} display={"flex"} gap={2} mt={1}>
                                <Button className={classes.cancelButton} onClick={() => { setIsOpenAddUpdateLotNumber(false); setData({}); setUniqueReelId(""); setIsEditMode(false); _getLotNumber() }}>Cancel</Button>
                                <Button className={classes.saveButton} onClick={() => _addUpdateLotNumber()} >Next</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
    )
}

export default AddUpdateLotNumber